import base from "../baseurl";
import token from "../getTk";

const showAll = async (cityId) => {
  const tokenA = token.get();
  const api = base.extend({
    hooks: {
      beforeRequest: [
        (request) => {
          request.headers.set("jwt", `${tokenA}`);
        },
      ],
    },
  });

  const show = await api.get("user-permissions/showall").json();
  return show;
};

export default showAll;
